<script>
import store from '@state/store'
import Title from '@components/section-title'

// TODO: promisse para retornar botão clicado

export default {
  components: {
    Title,
  },
  data() {
    return {
      show: false,
      loadings: {},
      persistent: false,
      closable: true,
      buttons: [
        {
          text: 'Confirmar',
          action: null,
          class: { success: true },
        },
      ],
      v2: false,
      type: '',
      typesMap: {
        danger: {
          icon: 'close-circle',
          color: 'danger', // #EB5757
          buttonBind: { alert: true },
        },
        warning: {
          icon: 'warning-status',
          color: 'warning-new', // #E0AF00
          buttonBind: { warning: true },
        },
        confirm: {
          icon: 'check-circle',
          color: 'success', // #56AF79
          buttonBind: { success: true },
        },
        neutral: {
          icon: 'check-circle',
          color: 'success', // #56AF79
          buttonBind: { success: true },
        },
      },
    }
  },
  computed: {
    modal() {
      return store.getters['feedback/modal']
    },
    modalIconName() {
      return this.typesMap[this.type]
        ? this.typesMap[this.type].icon
        : 'check-circle'
    },
    modalIconColor() {
      return this.typesMap[this.type]
        ? this.typesMap[this.type].color
        : 'success'
    },
    buttonsWidth() {
      return 98 / this.modal.buttons.length + '%'
    },
    dialogMaxWidth() {
      return this.v2
        ? this.modal['max-width'] || '500px'
        : this.modal['max-width'] || '550px'
    },
    dialogContentClass() {
      return (
        (this.modal.center ? '' : 'default-right-dialog') +
        ' ' +
        (this.modal.contentClass || '')
      )
    },
    cardStyle() {
      if (this.v2) {
        return {
          'min-height': this.modal.center ? '10vh' : '100vh',
        }
      }
      return {
        padding: '34px 30px 50px',
        'min-height': this.modal.center ? '10vh' : '100vh',
      }
    },
    cardClass() {
      if (!this.v2) return ''

      return this.modal.center
        ? this.$style.v_card
        : this.$style.v_card_no_radius
    },
    closeButtonClass() {
      return this.v2 ? this.$style.close_button_v2 : this.$style.close_button
    },
    closeButtonStyle() {
      return this.v2 ? {} : { 'z-index': 4 }
    },
    cardTitleClass() {
      return this.v2 ? 'justify-center pt-10 pb-8' : ''
    },
    cardTextClass() {
      return this.v2 ? `${this.$style.v_card_text} py-8 px-12` : ''
    },
    cardActionsClass() {
      return this.v2 ? 'd-flex justify-center py-8 px-12' : ''
    },
    textStyle() {
      return (this.modal.text || '').includes('\n')
        ? 'white-space: pre-line'
        : ''
    },
    showIcon() {
      return this.v2 && this.typesMap[this.type] && this.type !== 'neutral'
    },
  },
  watch: {
    modal(newValue) {
      this.show = newValue.show
      this.persistent = newValue.persistent
      this.closable = newValue.closable
      this.type = newValue.type
      this.v2 = newValue.v2
    },
    show(newValue, oldValue) {
      if (!newValue && oldValue !== newValue) {
        store.dispatch('feedback/closeModal')
      }
    },
  },
  methods: {
    async close(b) {
      if (this.loadings[b.text]) {
        return
      }
      this.$set(this.loadings, b.text, true)
      if (b.action) {
        await b.action()
      }
      this.$set(this.loadings, b.text, false)
      this.show = false
    },
    getButtonBind(button, index) {
      if (button.class || !this.v2) return button.class || {}
      if (this.modal.buttons.length > 1 && index === 0)
        return { bordered: true }

      return this.typesMap[this.type]
        ? this.typesMap[this.type].buttonBind
        : this.typesMap['neutral'].buttonBind
    },
  },
}
</script>

<template>
  <div class="v-application">
    <v-dialog
      v-model="show"
      :max-width="dialogMaxWidth"
      :persistent="persistent"
      :transition="modal.center ? null : 'dialog-right-transition'"
      :content-class="dialogContentClass"
    >
      <v-card :style="cardStyle" :class="cardClass">
        <!-- Close Button -->
        <v-btn
          v-if="closable"
          icon
          :small="v2"
          :class="closeButtonClass"
          :style="closeButtonStyle"
          @click="show = !show"
        >
          <icon-svg v-if="v2" name="close" size="15" color="#8e8e8e" />
          <icon-svg v-else name="close" class="modal-close-button" />
        </v-btn>

        <!-- Card Title -->
        <v-card-title :class="cardTitleClass">
          <span v-if="v2" :class="$style.modal_title">{{ modal.title }}</span>
          <Title v-else :title="modal.title" :subtitle="modal.subtitle" />
        </v-card-title>

        <!-- Card Text -->
        <v-card-text :class="cardTextClass">
          <div v-if="showIcon" class="mb-4">
            <icon-svg size="40" :name="modalIconName" :color="modalIconColor" />
          </div>

          <span
            v-if="modal.text"
            :style="textStyle"
            :class="v2 ? $style.modal_text : ''"
          >
            {{ modal.text }}
          </span>

          <div v-if="modal.html" v-html="modal.html"></div>
        </v-card-text>

        <!-- Card Actions -->
        <v-card-actions :class="cardActionsClass">
          <v-spacer v-if="!v2" />

          <template v-for="(b, i) in modal.buttons">
            <BaseButton
              :key="i"
              :loading="loadings[b.text]"
              v-bind="getButtonBind(b, i)"
              :class="v2 ? 'mx-2' : ''"
              :min-width="v2 ? buttonsWidth : undefined"
              @click="close(b)"
            >
              {{ b.text }}
            </BaseButton>
          </template>

          <v-spacer v-if="!v2" />
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<style lang="sass" module>
.close_button
  elevation: 1
  position: absolute
  right: 25px
  top: 25px
  color: var(--red) !important

.close_button_v2
  elevation: 1
  z-index: 4
  position: absolute
  right: 14px
  top: 14px
  color: #8e8e8e !important

.modal_title
  font-family: 'Geist', sans-serif
  font-weight: 400
  font-style: normal
  font-size: 16px
  line-height: 20px
  letter-spacing: 0px
  text-align: center
  color: #030309

.modal_text
  font-family: 'Archivo', sans-serif
  font-weight: 300
  font-style: normal
  font-size: 14px
  line-height: 1.2
  letter-spacing: 0px
  text-align: center
  color: #030309
  display: block

.v_card
  border-radius: 8px !important
  background-color: var(--neutral-50) !important

.v_card_no_radius
  background-color: var(--neutral-50) !important

.v_card_text
  border-top: 1px solid #8e8e8e80
  border-bottom: 1px solid #8e8e8e80
</style>
